import * as api from '../api';
import * as flight from './FlightModel';

export * from './BookingClass';
export * from './FlightFilterService';
export * from './FlightNavigationService';
export * from './FlightModel';
export * from './TrainModel';
export * from './FlightSearchFilters';
export * from './FlightSearchService';
export * from './ReservationModel';

export interface FlightFilterModel {
    uniqueId: string;
    visible: boolean;
    parentId: string;
    childCount: number;
}

export interface FlightFilterLegModel {
    durationMinutes: number;
}

export interface FlightFilterResult {
    flightsVisibleCount: number;
    flightsVisibleParentCount: number;
}

export interface FlightListModel {
    uniqueId: string;
    flight: flight.FlightModel;
}

export interface FlightSearchParams {
    from: string;
    to: string;
    departure: Date | null;
    return: Date | null;
    roundtrip: boolean;
    class: string;
    passengers: PassengersCount;
}

export interface FlightSearchResult {
    searchId: string;
    flights: flight.FlightModel[];
    flightsToFilter: FlightFilterModel[];
    banners: api.Banner[];
    duration: number; // Search duration in seconds
}

export enum Gender {
    Male,
    Female
}

export interface PassengersCount {
    adults: number;
    children: number;
    infants: number;
}

export interface SearchHistoryItem {
    from: string;
    to: string;
    departure: Date | null;
    return: Date | null;
    passengers: number;
    class: string;
    url: string;
    timestamp: number;
    expires: number;
}
